import { render } from "./ModalCustomerPaid.vue?vue&type=template&id=9607d012"
import script from "./ModalCustomerPaid.vue?vue&type=script&lang=js"
export * from "./ModalCustomerPaid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__